import type {PropositionConfig} from '@myparcel-frontend/proposition';
import type {DeepReadonly} from 'vue';
import type {NavigationGuardNext, RouteLocationNormalizedGeneric} from 'vue-router';
import {useProposition} from '@myparcel-frontend/proposition';

/**
 * @deprecated use the proposition guard directly from @myparcel-frontend/proposition
 */
export const propositionGuard = (
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedGeneric,
  callback: (proposition: DeepReadonly<PropositionConfig>) => boolean,
) => {
  const {proposition} = useProposition();

  if (callback(proposition.value)) {
    return true;
  } else {
    return {
      name: 'dashboard',
    };
  }
};
